import { render } from "./varificationModal.vue?vue&type=template&id=09cfeca1"
import script from "./varificationModal.vue?vue&type=script&lang=js"
export * from "./varificationModal.vue?vue&type=script&lang=js"

import "./varificationModal.vue?vue&type=style&index=0&id=09cfeca1&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__